import React, { useState } from "react";
import { Radio } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import CategoryInfo from "./CategoryInfo";
import { checkValue } from "../../../constant/helper";

const Category = ({
  changeStep,
  step = 0,
  tags,
  categories,
  isLoading,
  type,
}) => {
  const [selected, setSelected] = useState(0);
  const [openCatInfo, setOpenCatInfo] = useState(false);

  function onChange(e) {
    // e.stopPropagation();
    // setSelected(e.target.value);
    // changeStep(step + 1, e.target.title);
  }

  function selectStep(value, title, item) {
    setSelected(value);
    changeStep(step + 1, title, item);
  }

  function openInfo(item) {
    setOpenCatInfo(item);
  }

  const Item = ({ value, title, item }) => {
    return (
      <Radio
        className={"category-item"}
        onClick={() => selectStep(value, title, item)}
        value={value}
        title={title}
      >
        <span className="category-item-content-holder">
          <div className="category-item-content">
            <div
              className="item-title"
              onClick={() => selectStep(value, title, item)}
            >
              {title && title}
            </div>
          </div>
        </span>
        {item.hasOwnProperty("description") && checkValue(item.description) ? (
          <div className="item-info" onClick={() => openInfo(item)}>
            <InfoCircleOutlined />
          </div>
        ) : (
          ""
        )}
      </Radio>
    );
  };

  return (
    <>
      <div className="category-holder">
        {tags && tags.length > 0 && (
          <div className="tags">
            {tags.map((i, index) => {
              return (
                <span className={"tag"} key={`tags-${index}`}>
                  {i.slice(0, 20)}
                  {i.length > 20 ? "..." : " "}
                  <span className="icon-arrow-left-solid" />
                </span>
              );
            })}
          </div>
        )}
        {categories && categories.length > 0 ? (
          <>
            <h3 className={"title"}>
              {type === "dedicated_services"
                ? "لطفا نسبت به انتخاب بسته مورد نظر خود اقدام نمایید:"
                : "لطفا از بین دسته بندی های ذیل، انتخاب بفرمایید:"}
            </h3>
            <div className={"items"}>
              <Radio.Group onChange={onChange} value={selected}>
                {categories.map((i, index) => {
                  return (
                    <Item
                      title={i.name}
                      key={`categories-${index}`}
                      value={i.id}
                      item={i}
                    />
                  );
                })}
              </Radio.Group>
            </div>
          </>
        ) : (
          !isLoading && <h3 className={"title"}>لیست مورد نظر خالی است</h3>
        )}
      </div>
      <CategoryInfo openCatInfo={openCatInfo} setOpenCatInfo={setOpenCatInfo} />
    </>
  );
};

export default Category;
